import { DATES, MINUTES_SAFE_ZONE } from '../constants'

// Get all minutes from the `start` date to the `stop` date, it will
// return an array of `Date`s
const minutesInRange = (start, stop) => {
  let currentDate = start
  const ticks = []
  while (currentDate < stop) {
    ticks.push(currentDate)
    const date = new Date(currentDate)
    date.setTime(date.getTime() + 1 * 60 * 1000)
    currentDate = date
  }
  return ticks
}

// Get all the possible ticks, aka each minute a user can vote as a
// prediction, in one swoop, so the rest of the app does not need to
// handle anything weird.
//
// Returns a rather large array of `Date`s
const allTicks = DATES.reduce((r, [date, startHour, stopHour]) => {
  const start = new Date(date)
  start.setHours(startHour)
  const stop = new Date(date)
  stop.setHours(stopHour)
  r = r.concat(minutesInRange(start, stop))
  return r
}, [])

const cutoff = (date, minutes) => {
  const cutoff = new Date(date)
  cutoff.setTime(cutoff.getTime() + minutes * 60 * 1000)
  return cutoff
}

// Makes it easier to check if everything does what it needs to
//
// YYYY-MM-DDTHH:mm:ss.sssZ
// 2025-05-19T08:00:00
const nowHack = new URLSearchParams(window.location.search).get('__now')
const now = (nowHack && Date.parse(nowHack)) || new Date()
const cutoffPoint = cutoff(now, MINUTES_SAFE_ZONE)
const validTicks = allTicks.filter((d) => d > cutoffPoint && d > now)

// All the available ticks for that date (regardless of hours)
export const ticksForDate = (date) => validTicks.filter((d) => d.getDate() == date.getDate())

// An array of ints with the available hours for a date
export const hoursForDate = (date) => [...new Set(ticksForDate(date).map((d) => d.getHours()))]

// An array of ints with the available minutes for a date
export const minutesForHour = (date) =>
  ticksForDate(date)
    .filter((d) => d.getHours() == date.getHours())
    .map((d) => d.getMinutes())
